import * as actionTypes from "../actionTypes";

export const getWastes = function () {
  return { type: actionTypes.GET_WASTES };
};

export const deleteWaste = function (wasteId) {
  return { type: actionTypes.DELETE_WASTE, payload: wasteId };
};
